import React from 'react';
import TemplateSelector from './TemplateSelector';
import PersonalInfo from './PersonalInfo';
import ContactInfo from './ContactInfo';
import ButtonSettings from './ButtonSettings';
import ImageSettings from './ImageSettings';
import SocialMedia from './SocialMedia';
import StyleCustomization from './StyleCustomization';
import SocialIconsCustomization from './SocialIconsCustomization';
import ModulesCustomization from './ModulesCustomization';

const FormPanel = ({
  formData,
  updateFormData,
  templates,
  googleFonts,
  convertImageUrl,
  activeTab
}) => {

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return (
          <>
            <PersonalInfo
              formData={formData}
              updateFormData={updateFormData}
            />
            <ContactInfo
              formData={formData}
              updateFormData={updateFormData}
            />
            <ButtonSettings
              formData={formData}
              updateFormData={updateFormData}
            />
          </>
        );
      case 'images':
        return (
          <ImageSettings
            formData={formData}
            updateFormData={updateFormData}
            convertImageUrl={convertImageUrl}
          />
        );
      case 'social':
        return (
          <SocialMedia
            formData={formData}
            updateFormData={updateFormData}
          />
        );
      case 'design':
        return (
          <>
            <StyleCustomization
              formData={formData}
              updateFormData={updateFormData}
              googleFonts={googleFonts}
            />
            <SocialIconsCustomization
              formData={formData}
              updateFormData={updateFormData}
            />
            <div className="form-section-content">
              <h3 className="section-title">Personnalisation du modèle</h3>
              <ModulesCustomization
                formData={formData}
                updateFormData={updateFormData}
              />
            </div>
          </>
        );

      case 'models':
        return (
          <TemplateSelector
            templates={templates}
            selectedTemplate={formData.template}
            onTemplateChange={(template) => updateFormData('template', template)}

          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="form-panel">
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default FormPanel;